export default "__VITE_ASSET__BMmICDSX__"